<template>
    <svg width="132" height="56" viewBox="14 12 132 56" aria-hidden="true">
        <defs>
            <clipPath :id="clipLeftId"><circle cx="42" cy="40" r="28"></circle></clipPath>
            <clipPath :id="clipCenterId"><circle cx="80" cy="40" r="28"></circle></clipPath>
            <clipPath :id="clipRightId"><circle cx="118" cy="40" r="28"></circle></clipPath>
        </defs>
        <circle cx="42" cy="40" r="28" fill="#FFD3A8"></circle>
        <circle cx="80" cy="40" r="28" fill="#84D6D0"></circle>
        <circle cx="118" cy="40" r="28" fill="#E84C8E"></circle>
        <g :clip-path="`url(#${clipLeftId})`">
            <g :clip-path="`url(#${clipCenterId})`">
                <rect x="0" y="0" width="160" height="80" fill="#ADA8EE"></rect>
            </g>
        </g>
        <g :clip-path="`url(#${clipCenterId})`">
            <g :clip-path="`url(#${clipRightId})`">
                <rect x="0" y="0" width="160" height="80" fill="#FBB877"></rect>
            </g>
        </g>
    </svg>
</template>

<script setup lang="ts">
import { useId } from "vue";

const clipLeftId = useId();
const clipCenterId = useId();
const clipRightId = useId();
</script>
